<main>
  <h2>
    {{ proteinTitle.length > 95 ? (proteinTitle | slice:0:95) + "..." : proteinTitle }}
  </h2>
  @if (entryData().isComplex === true) {
    <div class="results-chip multichip"><span class="chip-title">{{ entryData().assemblyType +  entryData().oligomericState}}</span></div>
  }
  @if (entryData().isComplex === false) {
    <div class="results-chip monochip"><span class="chip-title">Monomer</span></div>
  }
  <p class="entry-title">
    {{ entryData().modelEntityId }}
  </p>
  <p class="entry-title">
    Version v{{ entryData().latestVersion }}
  </p>

  <div class="dataset">


    <span class="entry-title dataset">{{providerName}} dataset</span>
    <app-entry-status
      [isSummary]="true"
      [isProteome]="entryData().isUniProtReferenceProteome"
      [isReviewed]="entryData().isUniProtReviewed"
    ></app-entry-status>
  </div>

  <nav class="table-of-contents">
    <div class="container-border">
      <div class="nav-title" (click)="toggleNavigationLinks()">
        <h5>In this overview page</h5>
        <img src="/assets/img/mobile/arrow-{{isFullLinksDisplayed() ? 'up':'down'}}.svg" alt="arrow-up" width="24" height="25"/>
      </div>
      @if(isFullLinksDisplayed()){ @for(link of navigationLinks; track link.id){
        <a (click)="scrollToSection($event, link.id)">{{link.title}}</a>
        } } @else {
        <a (click)="scrollToSection($event, currentNavigationLink().id)">{{currentNavigationLink().title}}</a>
      }
    </div>
  </nav>

  @if (isOldUniprotEntry) {
    <section class="notification">
      <notification-msg
        [type]="'warning'"
        [message]="'This AlphaFold model was generated using a prior version of the UniProt sequence.'">
      </notification-msg>
    </section>
  }
  <!-- Information -->

  <h3 id="information">Information</h3>
  @if (entryData().isComplex === false) {
    <section class="structure-overview">
      @for (group of summaryTexts; track group; let isLast = $last) {
        <div class="domain-info-grouped">
          @for (item of group; track item) {
            @if (item.label === 'Experimental structures' && alsoFoundInData().length > 0) {
              <div class="info">
                <span class="info__title">Found in</span>
                <span class="info__content">
                  <article>
                    @for (record of alsoFoundInData(); track record; let isLastRecord = $last) {
                      <span>
                        {{ record?.complexName || 'Not named' }}
                        <a class="vf-link ext" [href]="'/entry/' + (record?.modelEntityId || '')" style="margin-left: 4px;" (click)="onRelatedEntryClick('found_in')">go to entry</a>
                        @if (!isLastRecord) {
                          <br />
                        }
                      </span>
                    }
                  </article>
                </span>
              </div>
            }
            <div class="info">
              <span class="info__title">{{ item.label }}</span>
              <span class="info__content">
                <ng-container>
                  <article>
                    @if (item.label != 'Status') {
                      <span>
                        @if (item.label === 'Biological function' && isBiologicalFunctionLoading()) {
                          <span>Loading...</span>
                        }
                        @if (item.show_long) {
                          <span>
                            @if (item.label !== 'Biological function' || !isBiologicalFunctionLoading()) {
                              <span [innerHTML]="item.text" [ngClass]="{'italic-text': item.italic}"></span>
                            }
                            @if (getShortenedText(item.text) != item.text) {
                              <a
                                class="vf-link"
                                (click)="switchText(item)"
                                >
                                <i class="icon icon-functional"></i> Show less
                              </a>
                            }
                          </span>
                        }
                        @if (!item.show_long) {
                          <span>
                            @if (item.label !== 'Biological function' || !isBiologicalFunctionLoading()) {
                              <span [innerHTML]="getShortenedText(item.text)" [ngClass]="{'italic-text': item.italic}"></span>
                            }
                            @if (checkIfHasToShowMore(item)) {
                              <a
                                class="vf-link"
                                (click)="switchText(item)"
                                >
                                <i class="icon icon-functional"></i> Show more
                              </a>
                            }
                          </span>
                        }
                      </span>
                    }
                    @if (item.source && item.source !== 'tooltip') {
                      <a
                        target="_blank"
                        href="{{ item.source_url }}"
                        class="vf-link ext"
                        style="margin-left:4px"
                        >
                        go to {{ item.source }}</a
                        >
                      }
                      @if (item.italic) {
                        <span
                          ><a
                          class="vf-link ext"
                      href="./search/organismScientificName/{{
                        commonService.escapeValue(item.searchText)
                      }}"
                          target="_blank"
                          style="margin-left:4px"
                          >go to search</a
                          ></span
                          >
                        }
                      </article>
                    </ng-container>
                  </span>
                </div>
              }
            </div>
          }
        </section>
      }
      @if (entryData().isComplex === true) {
        <section class="structure-overview">
          <div class="domain-info-grouped">
            <div class="info">
              <span class="info__title">
                Components
              </span>
              <article>
                @for (comp of summaryComponents(); track comp) {
                  <span class="comp-article">
                    <span class="info__content">{{ comp.stoichiometry }} {{ comp.stoichiometry > 1 ? 'copies' : 'copy' }} of {{ comp.identifier }}
                      @if (comp.range) {
                        [residues: {{ comp.range.start }} – {{ comp.range.end }}]
                      }
                      ({{ comp.uniprotDescription }})
                      <br />
                      @if (comp.uniprotAccession) {
                        <a href="{{uniprotBaseUrl}}{{comp.uniprotAccession}}" class="vf-link ext" style="margin-left: 0px;" target="_blank"> go to UniProt </a>
                      }
                    </span>
                  </span>
                }
              </article>
            </div>
            <div class="info">
              <span class="info__title">
                Source organism{{ complexData().organismScientificName?.length > 1 ? 's' : '' }}
              </span>
              <article>
                @for (organism of complexData().organismScientificName; track organism; let i = $index) {
                  <span class="comp-article">
                    <span class="info__content"><i>{{ organism }}</i>
                    <a href="./search/organismScientificName/{{commonService.escapeValue(organism)}}" class="vf-link ext" style="margin-left: 0px;" target="_blank"> go to search</a>
                  </span>
                </span>
              }
            </article>
          </div>
          @if (curatedComplexId) {
            <div class="info">
              <span class="info__title">
                Curated complex
              </span>
              <article>
                <span>
                  <span class="info__content">This complex is curated
                    <a [href]="getCuratedComplexPortalUrl()" style="margin-left: 0px;" class="vf-link ext" target="_blank">go to Complex portal</a>
                  </span>
                </span>
              </article>
            </div>
          }
        </div>
      </section>
    }

    <!-- Model Confidence Summary -->
    <section id="model-confidence-summary" class="primebtn">
      <button
        class="vf-button vf-button--primary vf-button--search-pdbe" (click)="navigateTo3DView('MConfidence')">
        View 3D and annotations
      </button>
    </section>
    <h3>Model Confidence Summary</h3>
    <div class="structure-overview" style="display: flex; flex-direction: column;">
      <div class="info">
        <p class="info__title">Global quality</p>
        <p class="info__content">
          @if (entryData().isComplex === true) {
            average pLDDT: {{ complexData().globalMetricValue }} ({{ getPlddtLevel(complexData().globalMetricValue) }})
          } @else {
            average pLDDT: {{ averageplddtDisplay }}
          }
        </p>
      </div>
      @if (entryData().isComplex === false) {
        <div class="info">
          <p class="info__title">pLDDT distribution</p>
          <article style="display:flex; flex-direction: row;">
            <div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #0053d6;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtVeryHigh * 100) | number : '1.0-1' }}% Very high
              </div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #65cbf3;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtConfident * 100) | number : '1.0-1' }}% High
              </div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #ffdb13;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtLow * 100) | number : '1.0-1' }}% Low
              </div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #ff7d45;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtVeryLow * 100) | number : '1.0-1' }}% Very low
              </div>
            </div>
          </article>
        </div>
      }
      @if (entryData().isComplex === true) {
        <div class="info">
          <p class="info__title">Interface quality</p>
          <article style="display:flex; flex-direction: row;">
            <div>
              <div class="plddtlegends">
                ipSAE: {{ complexData().complexPredictionAccuracy_ipSAE }} ({{ getipSAELevel(complexData().complexPredictionAccuracy_ipSAE) }})
              </div>
              <div class="plddtlegends">
                ipTM: {{ complexData().complexPredictionAccuracy_ipTM }}
              </div>
              <div class="plddtlegends">
                pDockQ2: {{ complexData().complexPredictionAccuracy_pDockQ2 }}
              </div>
              <div class="plddtlegends">
                LIS: {{ complexData().complexPredictionAccuracy_LIS }}
              </div>
            </div>
          </article>
        </div>
      }
      <div class="legendsmobile">
        <linear-legends type="plddt"></linear-legends>
      </div>
      <div class="legendstext">
        <span>pLDDT is a per-residue measure of local confidence <br />
          <a (click)="gaService.eventEmitter(
                'link_visit',
                'home_href_click',
                'click',
                'learn more mobile',
                '')" href="./faq/#faq-12" target="_blank" class="licenseLink" target="_blank">
            Learn more...
          </a></span>
        </div>
        <molstar-gallery></molstar-gallery>
        @if (entryData().paeDocUrl) {
          <app-pae-view
            class="overview-pae"
            [paeid]="'mobile-paeviewer'"
            [isMobilePae]="true"
            (selectedRegion)="cmSelectionUpdate($event)"
        (click)="
          gaService.eventEmitter(
            'pae-click',
            'pae',
            'click',
            accession(),
            undefined
          )
          "
            >
          </app-pae-view>
        }
      </div>
      <!-- Audit History -->
      <h3 id="audit-history">Audit history</h3>
      <span class="audit-info"><b>Model creation date:</b> <span class="infodate"> {{ entryData()?.modelCreatedDate | date: 'd MMM y' }}</span>
    </span>
    @if (entryData()?.sequenceVersionDate) {
      <br>
      <span class="audit-info"><b>Sequence version date:</b> <span class="infodate"> {{ entryData()?.sequenceVersionDate | date: 'd MMM y' }}</span>
    </span>
    }

    <!-- Dataset Publications -->
    <h3 id="dataset-publications">Dataset Publications </h3>

    @if (providerData()?.citations?.length) {
      <div>
        @for (citation of providerData().citations; track citation) {
          <div class="publication-desc">
            <a
              target="_blank"
              [href]="citation.url || '#'"
              class="licenseLink"
              >
              {{ citation.description || '' }}
            </a><br/>
            <br/>
          </div>
        }
      </div>
    }

    <!-- Similar Proteins -->

    <h3 id="similar-proteins">Similar Proteins</h3>
    @if (entryData()?.isComplex) {
      <section>
        <span class="qualify-span secondary"><b>No information available.</b></span><br/>
        <span class="qualify-span secondary">Similar proteins will appear here as new data is added in future updates.</span>
      </section>
    }
    @if (!entryData()?.isComplex) {
      <section>
        <span class="qualify-span secondary">The section highlights proteins that are evolutionarily related, either by <b>
          sequence</b> or <b>structure.</b>
        </span>
        <br />
        <div class="qualify-span-title">Structure similarity cluster</div>
        <span class="qualify-span structure-overview">
          <div class="info">
            <span class="info__title">Sequence level</span>
            <span class="info__content">
              {{ clustermmseqData()?.clusterTotal || 0 }} {{ (clustermmseqData()?.clusterTotal || 0) === 1 ? 'protein' : 'proteins' }}
            </span>
          </div>
          <div class="info">
            <span class="info__title">Structure level</span>
            <span class="info__content">
              {{ clusterfoldseekData()?.clusterTotal || 0 }} {{ (clusterfoldseekData()?.clusterTotal || 0) === 1 ? 'protein' : 'proteins' }}
            </span>
          </div>
        </span>
        <span class="qualify-span secondary">These proteins share function and evolutionary history.
        <a (click)="gaService.eventEmitter(
          'link_visit',
          'home_href_click',
          'click',
          'learn more mobile',
          '')" href="./faq/#faq-21" target="_blank" class="licenseLink" target="_blank">
            Learn more about this method...
          </a>
        </span>
        <div class="qualify-span-title">Similar structures</div>
        <span class="qualify-span structure-overview">
          <span class="qualify-span secondary">You can explore proteins with similar structures in the AlphaFold DB and the latest PDB releases. <br />
          <a (click)="gaService.eventEmitter(
                  'link_visit',
                  'home_href_click',
                  'click',
                  'learn more mobile',
                  '')" href="./faq/#faq-24" target="_blank" class="licenseLink" target="_blank">
              Learn more about this method...
            </a></span>
          </span>
          <section class="primebtn">
            <button
              class="vf-button vf-button--primary vf-button--search-pdbe"  (click)="navigateTo3DView('SProteins')">
              Discover similar proteins
            </button>
          </section>
        </section>
      }

      <!-- Feedback -->

      <section class="feedback" id="feedback">
        <div class="feedbacktitle">Share your feedback on the structure</div>
        <a class="vf-button vf-button--secondary vf-button--search-pdbe" style="color: #3B6FB6"
          href="https://docs.google.com/forms/d/e/1FAIpQLScT5V3h_-YLbeScz5vYBd8l1lcmdXuqViyXC0c0gRl0uOU1pw/viewform?entry.2122993774={{entryData().modelEntityId}}"
        target="_blank">Report an issue</a>
      </section>

      <!-- Help -->
      <h3 id="help"></h3>
      <entry-page-footer [isEntryPage]="true" />
    </main>
